import axios from 'axios';
import {get} from 'lodash';
import {FeathersVuexFindAll} from '@/utils';

export const CALENDAR_FORMAT = 'yyyy-MM-dd';
export const LOCAL_SERVER_URL = 'http://localhost:3030';
// export const BASE_SERVER_URL = 'https://cors-anywhere.herokuapp.com/https://eaa.fwd.wf';
export const PRODUCTION_SERVER_URL = 'https://api.soplushbeauty.com';

export const HELP_EMAIL = 'help@soplushbeauty.com';
export interface BookingDialogEntry {
    title: string;
    content: any[];
}
export interface VuetifyColorSetting {
    dark: boolean;
    color: string;
}

export interface BookingUIConfig {
    status: string;
    label: string;
    color: string;
    icon: string;
    title: string;
    dark: boolean;
    displayedByDefault: boolean;
}

export const stripeKeys = {
    public: 'pk_live_gVzFAroxGDPxfLJzFvRzoT9l00Y7yFCC3o',
    secret: 'sk_live_rhdcSUXfg7tLcl92qU2qJPS800hE6bPpeN',
};
export const testStripeKeys = {
    public: 'pk_test_wrTh8wy1ipSfTmq5ZEIXZdFX00tVdgHLAO',
    secret: 'sk_test_uaXs22Z0WDCx2HKvYOxk3olZ009ECkoRJJ',
};
export const GIFT_UP_API_URL = 'https://api.giftup.app';
export const GIFT_UP_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhZmE1NzgyZS1iZjNjLTQ1NGUtYjY5Mi1iYmZlY2UyZjc3MmEiLCJzdWIiOiJiaWxsaW5nQHNvcGx1c2hiZWF1dHkuY29tIiwiZXhwIjoxODc2MzQ5MTc4LCJpc3MiOiJodHRwczovL2dpZnR1cC5hcHAvIiwiYXVkIjoiaHR0cHM6Ly9naWZ0dXAuYXBwLyJ9.sg6gcnnBHSN056RWCSLrlpcRaEgOOZZzyEKmLPlHERM	';
export const GOOGLE_MAPS_KEY = 'AIzaSyCLmR3rOpzW52geWOrPvr8w9N9gaADpxOU';
export const GOOGLE_GEOCODE_KEY = 'AIzaSyCpQucCGzKEC3JV-pF9bPr_GPbkRTl0RFM';
export function generateToken(n) {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let token = '';
    for (let i = 0; i < n; i++) {
        token += chars[Math.floor(Math.random() * chars.length)];
    }
    return token;
}

export async function getStoreSettings(Setting): Promise<any> {
    let settingsObject = {};
    const settings = await Setting.find({});
    if (settings.total === 0) {
        const setting = new Setting();
        settingsObject = await setting.create();
    } else {
        settingsObject = settings.data[0];
    }
    return settingsObject;
}

export function nil(x: any | number | string | null | undefined, falsyCounts: boolean = false) {
    if (falsyCounts) {
        if (x === undefined || x === null) {
            return true;
        }
        if (Array.isArray(x)) {
            return x.length === 0;
        }
        if (typeof x === 'object') {
            return nil(Object.keys(x), true);
        }
        if (typeof x === 'number') {
            return x === 0;
        }
        if (typeof x === 'string') {
            return !Boolean(x);
        }
        if (typeof x === 'boolean') {
            return !x;
        }
        console.log(x);
        throw Error('I don\'t know what this is??');
    } else {
        return x === undefined || x === null;
    }
}
export function multiNil(x: any, path: string, falsyCounts: boolean = false) {
    const newPath = path.split('.');
    const prop = newPath.shift();
    if (nil(prop) || nil(x[prop], falsyCounts)) {
        return true;
    }
    if (newPath.length === 0) {
        return nil(x[prop], falsyCounts);
    }
    return multiNil(x[prop], newPath.join('.'));
}
export function multiNilDefault(x: any, path: string, defaultValue: any, falsyCounts: boolean = false) {
    if (multiNil(x, 'path.prop')) { return defaultValue; }
    return get(x, path);
}
export function getBaseURL() {
    return document.location.hostname === 'localhost' ? LOCAL_SERVER_URL : PRODUCTION_SERVER_URL;
}
export const axiosInstance = axios.create({
    baseURL: `${getBaseURL()}/`,
    timeout: 1000,
});

export function parseify(obj: any) {
    return JSON.parse(JSON.stringify(obj));
}

export function isEmail(email) {
    // thanks https://gist.github.com/badsyntax/719800
    return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(email);
}

export function isPhone(phone) {
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone);
}

export const IMAGE_POSITION = {
    LT: 'left top',
    LC: 'left center',
    LB: 'left bottom',
    RT: 'right top',
    RC: 'right center',
    RB: 'right bottom',
    CT: 'center top',
    CC: 'center center',
    CB: 'center bottom',
};

export const IMAGE_POSITION_ORDERED = [
    IMAGE_POSITION.LT,
    IMAGE_POSITION.CT,
    IMAGE_POSITION.RT,
    IMAGE_POSITION.LC,
    IMAGE_POSITION.CC,
    IMAGE_POSITION.RC,
    IMAGE_POSITION.LB,
    IMAGE_POSITION.CB,
    IMAGE_POSITION.RB,

];
/*
 X  placing             Order has been created, but checkout is not complete
 O  paid                Order has gone through checkout, and payment has been confirmed but pros have yet to be alerted
 X  requires_review     Requires manual acceptance
 X  not_accepted        Order has been denied manually
 O  accepted            Order has been accepted (manually or otherwise) and pros have been notified
 O  fulfilled           All bookings in the order have passed, the order is considered completed.
 X  cancelling          Customer has requested the order be cancelled
 X  cancelled           Order has been cancelled and funds should be released back to the customer
 X  abandoned           Order never got through checkout and was eventually marked abandoned.
  */
export const ORDER_STATUS = {
    PLACING: 'PLACING',
    PAID: 'PAID',
    REQUIRES_REVIEW: 'REQUIRES_REVIEW',
    NOT_ACCEPTED: 'NOT_ACCEPTED',
    ACCEPTED: 'ACCEPTED',
    FULFILLED: 'FULFILLED',
    CANCELLING: 'CANCELLING',
    CANCELLED: 'CANCELLED',
    ABANDONED: 'ABANDONED',
};

export const ORDER_STATUS_METADATA: BookingUIConfig[] = [
    {
        status: ORDER_STATUS.PLACING,
        label: 'Placing',
        color: 'blue lighten-3',
        dark: true,
        icon: 'fas fa-calendar-minus',
        title: 'Placed But Not Paid For',
        displayedByDefault: false,
    },
    {
        status: ORDER_STATUS.PAID,
        label: 'Paid',
        color: 'success',
        dark: true,
        icon: 'fas fa-calendar-check',
        title: 'Paid For',
        displayedByDefault: true,
    },
    {
        status: ORDER_STATUS.REQUIRES_REVIEW,
        label: 'Review Required',
        color: 'warning',
        dark: true,
        icon: 'fas fa-calendar-minus',
        title: 'Requires Review',
        displayedByDefault: false,
    },
    {
        status: ORDER_STATUS.NOT_ACCEPTED,
        label: 'Review Rejected',
        color: 'error',
        dark: true,
        icon: 'fas fa-calendar-times',
        title: 'Not Accepted Bookings',
        displayedByDefault: false,
    },
    {
        status: ORDER_STATUS.ACCEPTED,
        label: 'Open',
        color: 'light-green',
        dark: true,
        icon: 'fas fa-calendar-check',
        title: 'Available Bookings',
        displayedByDefault: true,
    },
    {
        status: ORDER_STATUS.FULFILLED,
        label: 'Fulfilled',
        color: 'success',
        dark: true,
        icon: 'fas fa-check-circle',
        title: 'Fulfilled Bookings',
        displayedByDefault: true,
    },
    {
        status: ORDER_STATUS.CANCELLING,
        label: 'Cancelling',
        color: 'error lighten-1',
        dark: true,
        icon: 'fas fa-calendar-times',
        title: 'Requested Cancellation',
        displayedByDefault: false,
    },
    {
        status: ORDER_STATUS.CANCELLED,
        label: 'Cancelled',
        color: 'error',
        dark: true,
        icon: 'fas fa-calendar-times',
        title: 'Cancelled Bookings',
        displayedByDefault: false,
    },
    {
        status: ORDER_STATUS.ABANDONED,
        label: 'Abandoned',
        color: 'error',
        dark: true,
        icon: 'fas fa-question-circle',
        title: 'Bookings That Never Completed',
        displayedByDefault: false,
    },
];

export const CLAIM_STATUS = {
    ASSIGNED: 'ASSIGNED',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    UNKNOWN: 'UNKNOWN',
};
export const STRIPE_PAYMENT_INTENT_STATUSES = {
    REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
    REQUIRES_CONFIRMATION: 'requires_confirmation',
    REQUIRES_ACTION: 'requires_action',
    PROCESSING: 'processing',
    REQUIRES_CAPTURE: 'requires_capture',
    CANCELED: 'canceled',
    SUCCEEDED: 'succeeded',
};
export const BOOKING_STATUS = {
    WAITING_ON_REQUESTED_PRO: 'WAITING_ON_REQUESTED_PRO',
    WAITING_ON_ANY_PRO: 'WAITING_ON_ANY_PRO',
    ACCEPTED_BY_REQUESTED_PRO: 'ACCEPTED_BY_REQUESTED_PRO',
    ACCEPTED_BY_ANY_PRO: 'ACCEPTED_BY_ANY_PRO',
    FULFILLED: 'FULFILLED',
    CANCELLED: 'CANCELLED',
};
export const UPLOAD_PURPOSES = {
    IMPORT_VENDORS: 'import-vendors',
    IMPORT_PURCHASABLES: 'import-purchasables',
    IMAGE_VENDOR_PROFILE: 'image-vendor-profile',
    IMAGE_VENDOR_ADDITIONAL: 'image-vendor-additional',
    IMAGE_CUSTOMER: 'image-customer',
    IMAGE_BLOG: 'image-blog',
    IMAGE_SITE: 'image-site',
    APPLICANT_HEADSHOT: 'applicant-headshot',
    APPLICANT_KIT: 'applicant-kit',
    IMAGE_SERVICE: 'image-service',
};
export const POST_STATUS = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    TRASHED: 'TRASHED',
};
export const BOOKING_HOURS = {
    hours: [
        {header: 'Early Morning', times:[0,1,2,3,4,5]},
        {header: 'Morning', times: [6, 7, 8, 9, 10, 11]},
        {header: 'Afternoon', times: [12, 13, 14, 15, 16, 17]},
        {header:"Evening", times:[18,19,20,21,22,23]},
    ],
    getHours(settings) {
        let output = [];
        for (const hour of this.hours) {
            output = [...output, ...hour.times];
        }
        return output.sort((a, b) => a - b).filter(x => x>= settings.businessHoursStart && x <= settings.businessHoursEnd);
    },
};
export const CONDITIONAL_DISCOUNTS = {
    BRIDAL_PARTY_10PERCENT_OFF(state) {
        const categoryOk = nil(state.category) || state.category.name === 'Weddings';
        const serviceCategoryOk = nil(state.services, true) || state.services.map((x) => x.categoryModel).filter((x) => x.name !== 'Weddings').length === 0;
        if (!categoryOk) {
            return `Can't apply this discount under the category ${state.category.name}`;
        }
        if (!serviceCategoryOk) {
            return `Can't apply the discount when one of your bookings is not in the Wedding category`;
        }
        const hasGuests = !nil(state.guests, true);
        if (hasGuests) {
            const guestAmount = state.guests.reduce((acc, val) => acc + val);
            if (guestAmount < 10) {
                return `Can't apply this discount until you add ${10 - guestAmount} guests`;
            }
        }
        return false;
    },
};
export const drawerNavigation = [
    {
        heading: 'Dashboard',
        roles: ['admin', 'vendor'],
    },
    {
        icon: 'fas fa-home',
        text: 'Home',
        path: '/dashboard',
        exact: true,
        roles: ['admin'],
    },
    {
        icon: 'fas fa-calendar',
        text: 'Bookings',
        path: '/dashboard/bookings',
        roles: ['admin', 'vendor'],
    },
    {
        icon: 'fas fa-id-card',
        text: 'Profile',
        path: '/dashboard/profile',
        roles: ['vendor'],
    },
    {
        icon: 'fas fa-shopping-cart',
        text: 'Orders',
        path: '/dashboard/orders',
        roles: ['admin'],
    },
    {
        icon: 'fas fa-grin',
        text: 'Customers',
        path: '/dashboard/customers',
        roles: ['admin'],
    },
    {
        icon: 'fas fa-store',
        text: 'Pros',
        path: '/dashboard/vendors',
        roles: ['admin'],
    },
    {
        icon: 'fas fa-briefcase',
        text: 'Services',
        path: '/dashboard/services',
        roles: ['admin'],
    },
    /*{
        icon: 'fas fa-edit',
        text: 'Pages',
        path: '/dashboard/pages',
        roles: ['admin'],
    },*/
    {
        icon: 'fas fa-user-tie',
        text: 'Pro Applications',
        path: '/dashboard/applications',
        roles: ['admin'],
    },
    {
        icon: 'fas fa-images',
        text: 'Images',
        path: '/dashboard/images',
        roles: ['admin'],
    },
    {
        icon: 'fas fa-cog',
        text: 'Settings',
        path: '/dashboard/settings',
        roles: ['admin'],
    },
    {
        divider: true,
        roles: ['admin', 'vendor'],
        mobileOnly: true,
    },
    {
        heading: 'Site Navigation',
        roles: ['admin', 'vendor'],
        mobileOnly: true,
    },

];
function priceDisplay(price: number): string {
    return '$' + price.toFixed(2);
}
export const serviceHeaders = [
    {
        text: 'Category',
        align: 'left',
        sortable: true,
        value: 'category',
        func: (item: any) => nil(item.categoryModel) ? '' : item.categoryModel.name,
    },
    {
        text: 'Tier',
        align: 'left',
        sortable: true,
        value: 'tier',
        func: (item: any) => nil(item.tierModel) ? '' : item.tierModel.name,
    },
    {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
        html(item: any) {
            let imageUrl = '';
            if (item.imageModels.length === 0) {

            } else if (!nil(item.imageModels[0].thumb, true)) {
                imageUrl = item.imageModels[0].thumb;
            } else {
                imageUrl = item.imageModels[0].file;
            }

            const image = imageUrl !== ''
                ? `<img class="dashboard-service-image" src='${imageUrl}' />`
                : '';
            return `<div class="dashboard-service-wrapper">${image} ${item.name}</div>`;
        },
    },
    {
        text: 'Types',
        align: 'left',
        sortable: false,
        value: 'serviceTypes',
        func: (item: any) => nil(item.serviceTypeModels) ? '' : item.serviceTypeModels.map((x) => x.name).join(', '),
    },
    {
        text: 'Price',
        align: 'left',
        sortable: true,
        value: 'price',
        func: (item: any) => priceDisplay(item.price),
    },
    {
        text: 'Pro\'s Cut',
        align: 'left',
        sortable: true,
        value: 'price',
        func: (item: any) => priceDisplay(item.vendorCut),
    },
];
export const orderStatusConfig = {
    [ORDER_STATUS.PLACING]: {
        text: 'Placing',
        color: 'info',
        explanation: 'Order has been created, but checkout is not complete.',
    },
    [ORDER_STATUS.ABANDONED]: {
        text: 'Abandoned',
        color: 'warning',
        explanation: 'Order never got through checkout and was eventually marked abandoned.',
    },
    [ORDER_STATUS.PAID]: {
        text: 'Paid',
        color: 'success',
        explanation: 'Order has gone through checkout, and payment has been confirmed but pros have yet to be alerted.',
    },
    [ORDER_STATUS.REQUIRES_REVIEW]: {
        text: 'Requires Review',
        color: 'warning',
        explanation: 'Requires manual acceptance.',
    },
    [ORDER_STATUS.ACCEPTED]: {
        text: 'Accepted',
        color: 'success',
        explanation: 'Order has been accepted and pros have been notified.',
    },
    [ORDER_STATUS.NOT_ACCEPTED]: {
        text: 'Not Accepted',
        color: 'error',
        explanation: 'Order has been denied manually.',
    },
    [ORDER_STATUS.CANCELLING]: {
        text: 'Cancelling',
        color: 'warning',
        explanation: 'Customer has requested the order be cancelled.',
    },
    [ORDER_STATUS.CANCELLED]: {
        text: 'Cancelled',
        color: 'error',
        explanation: 'Order has been cancelled and funds should be released back to the customer.',
    },
    [ORDER_STATUS.FULFILLED]: {
        text: 'Fulfilled',
        color: 'success',
        explanation: 'All bookings in the order have passed, the order is considered completed.',
    },
};
export function getPreRenderedRoutes(routes): string[] {
    routes = routes.filter((x) => !nil(x.children, true) || !multiNil(x, 'meta.preRender', true));
    const paths = [];
    for (const route of routes) {
        let basePath = route.path;
        if (basePath === '') { basePath = '/'; }
        if (!nil(route.children, true)) {
            if (!multiNil(route, 'meta.preRender', true)) {
                paths.push(basePath);
            }
            for (const child of route.children) {
                if (!multiNil(child, 'meta.preRender', true)) {
                    paths.push(`${basePath}/${child.path}`);
                }
            }
        } else {
            paths.push(basePath);
        }
    }
    return paths;
}
